import {
  errorAction,
  requestAction,
  successAction,
  types,
} from "@authzsvc/api-lib";

const initialState = {
  loading: false,
  data: null,
};

const serviceCollectionEligibilitySettings = (state = initialState, action) => {
  switch (action.type) {
    case errorAction(types.GET_SERVICE_COLLECTION_ELIGIBLITY_SETTINGS):
      return {
        ...state,
        loading: false,
      };
    case successAction(types.GET_SERVICE_COLLECTION_ELIGIBLITY_SETTINGS):
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      };
    case requestAction(types.GET_SERVICE_COLLECTION_ELIGIBLITY_SETTINGS):
      return {
        ...state,
        data: null,
        loading: true,
      };
    default:
      return state;
  }
};

export default serviceCollectionEligibilitySettings;
